// @mui material components
import Card from "@mui/material/Card";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Billing page components
import Invoice from "layouts/billing/components/Invoice";

// import { Timestamp } from "firebase/firestore";

function Invoices({ chemicals, units, invoices }) {
  const TimestamptoDate = (timestamp) => {
    const { seconds } = timestamp;
    const { nanoseconds } = timestamp;

    const milliseconds = seconds * 1000 + nanoseconds / 1e6;
    const date = new Date(milliseconds).toDateString();
    return date;
  };

  const navigate = useNavigate();
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          Invoices
        </MDTypography>

        <MDButton
          variant="outlined"
          color="info"
          size="small"
          onClick={() => {
            navigate("/billing/createinvoice", {
              state: {
                data: { chemicals, units },
              },
            });
          }}
        >
          Create New Invoice
        </MDButton>
      </MDBox>
      <MDBox p={2}>
        <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          {invoices
            .sort((a, b) => b.endDate.seconds - a.endDate.seconds)
            .map(
              (invoice) =>
                !invoice.archive && (
                  <MDBox
                    key={invoice.key}
                    sx={{
                      border: invoice.isEndOfYear ? "2px solid red" : "none", // Add border if isEndOfYear is true
                      borderRadius: "8px", // Optional: Add rounded corners
                      padding: "8px", // Optional: Add padding for better appearance
                      "&:hover": {
                        backgroundColor: "lightgrey", // Change background color on hover
                      },
                    }}
                  >
                    <Invoice
                      date={
                        invoice.isEndOfYear
                          ? `Year End Spray Data - ${TimestamptoDate(invoice.endDate)}`
                          : `${TimestamptoDate(invoice.startDate)} - ${TimestamptoDate(
                              invoice.endDate
                            )}`
                      }
                      id={invoice.key}
                    />
                  </MDBox>
                )
            )}
        </MDBox>
      </MDBox>
    </Card>
  );
}
// Typechecking props
Invoices.propTypes = {
  chemicals: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  units: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  invoices: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};
export default Invoices;
